// extracted by mini-css-extract-plugin
module.exports = {"row":"WorkspaceNameEditor_row__wiwpZ","editRow":"WorkspaceNameEditor_editRow__9scdH","title":"WorkspaceNameEditor_title__qR7aH","input":"WorkspaceNameEditor_input__tGrvU"};